"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const storeDetailsInputs = [
  {
    name: "storeLocatorUrl",
    type: "url",
  },
  {
    name: "componentLevelLanguage",
    type: "string",
    required: false,
    friendlyName: "Component level language override",
  },
] as const satisfies Inputs;

export const StoreDetailsComponent: RegisteredComponent = {
  name: "StoreDetails",
  component: dynamic(async () => (await import("./StoreDetails")).StoreDetails),
  inputs: storeDetailsInputs,
};
